import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXT,
  attribute: 'reporting_email',
  label: {
    default: 'Reporting Email',
    short: 'Reporting Email',
  },
});
